export default "__VITE_PUBLIC_ASSET__3abf9a38__"